import { apiFetch } from "@/integrations/backend/client";

export type AdminPrompt = { id: string; name: string; slug: string; description: string };

export async function listPrompts(): Promise<AdminPrompt[]> {
  const res = await apiFetch("/api/v1/prompts", { method: "GET" });
  if (!res.ok) throw new Error(`prompts_list_failed:${res.status}`);
  return (await res.json()) as AdminPrompt[];
}

export async function createPrompt(input: Omit<AdminPrompt, "id">): Promise<{ id: string }> {
  const res = await apiFetch("/api/v1/prompts", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });
  if (!res.ok) throw new Error(`prompt_create_failed:${res.status}`);
  return (await res.json()) as { id: string };
}

export async function updatePrompt(id: string, patch: Partial<Omit<AdminPrompt, "id">>): Promise<void> {
  const res = await apiFetch(`/api/v1/prompts/${id}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(patch),
  });
  if (!res.ok) throw new Error(`prompt_update_failed:${res.status}`);
}

export async function deletePrompt(id: string): Promise<void> {
  const res = await apiFetch(`/api/v1/prompts/${id}`, { method: "DELETE" });
  if (!res.ok) throw new Error(`prompt_delete_failed:${res.status}`);
}
